import { SlickBlogSlider, SlickSlider } from '../minor-components/SlickSlider'
import { Card } from '../minor-components/Card'
import { baseURL } from '../../constants/baseURL';
import { Link } from 'react-router-dom';

export const SinglDashboardProduct = (props) => {
    return (
        <>
              {props.istype === 'categories' ? (
                <div className="grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 gap-6">
                    {props.products?.map((item, index) => (
                        <div key={item._id} className='px-4'>
                            <Card 
                                svg={`${baseURL}${item.categoryPhoto}`} 
                                title={item.brand}
                                value={index}
                                type="category"
                                setSearchQuery={props.setSearchQuery}
                                searchQuery={props.searchQuery}
                            /> 
                        </div>
                    ))}
                </div>
                    
            ) : props.isBlogType ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
                    {props.blogs?.map((blog, index) => (
                        <div key={blog?._id || index} className="h-full">
                            <div className="bg-white h-full shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-200 rounded-2xl overflow-hidden">
                                <a href={`/blog/${blog?._id}`} className="block">
                                    <img 
                                        className="w-full h-56 object-cover" 
                                        src={blog?.blogImage ? baseURL + blog?.blogImage : "https://flowbite.com/docs/images/blog/image-1.jpg"} 
                                        alt={blog?.blogHeading || "Blog image"} 
                                    />
                                </a>
                                <div className="p-6">
                                    <a href={`/blog/${blog?._id}`} className="block mb-4">
                                        <h2 
                                            className="text-xl font-bold text-gray-900 line-clamp-2 mb-2"
                                            dangerouslySetInnerHTML={{ 
                                                __html: blog?.blogHeading || '' 
                                            }}
                                        />
                                    </a>
                                    <div 
                                        className="text-gray-600 line-clamp-3 mb-4"
                                        dangerouslySetInnerHTML={{ 
                                            __html: blog?.data ? blog?.data.slice(0, 150) + '...' : '' 
                                        }}
                                    />
                                    <div className="flex justify-center">
                                        <a 
                                            href={`/blog/${blog?._id}`}
                                            className="inline-block px-6 py-2.5 bg-[#3e0d31] text-white font-medium rounded-full text-sm hover:bg-[#2a0921] transition-colors duration-300"
                                        >
                                            Read more
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <SlickSlider className='flex'>
                    {props.products?.map((item, index) => (
                        <div key={item._id || index} className='px-4'>
                            <Card 
                                svg={`${baseURL}${item.productPhoto}`} 
                                title={item.name} 
                                desc={item.description} 
                                price={item.price} 
                                item={item}
                                value={index}
                                getItem={props.handleItem}
                                setSearchQuery={props.setSearchQuery}
                                searchQuery={props.searchQuery}
                            /> 
                        </div>
                    ))}
                </SlickSlider>
            )}
        </>
    );
};